import { IonButton, IonContent } from "@ionic/react";
import React from "react";
import { useRecoilState } from "recoil";
import { loggedInUserState } from "../../data/atoms";

interface Props {
  setShowModal2: Function;
}

const BusinessInformationModal: React.FC<Props> = ({ setShowModal2 }) => {
  const [userToEdit, setLoggedInUser] = useRecoilState(loggedInUserState);

  function handleClick() {
    setShowModal2(false);
  }

  return (
    <IonContent placeholder={undefined}>
      <div className="business-information-wrap">
        <svg
          width="79"
          height="72"
          viewBox="0 0 79 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M39.5 16V8C39.5 3.6 35.99 0 31.7 0H8.29999C4.01 0 0.5 3.6 0.5 8V64C0.5 68.4 4.01 72 8.29999 72H70.7C74.9899 72 78.4999 68.4 78.4999 64V24C78.4999 19.6 74.9899 16 70.7 16H39.5ZM16.1 64H8.29999V56H16.1V64ZM16.1 48H8.29999V40H16.1V48ZM16.1 32H8.29999V24H16.1V32ZM16.1 16H8.29999V8H16.1V16ZM31.7 64H23.9V56H31.7V64ZM31.7 48H23.9V40H31.7V48ZM31.7 32H23.9V24H31.7V32ZM31.7 16H23.9V8H31.7V16ZM66.7999 64H39.5V56H47.3V48H39.5V40H47.3V32H39.5V24H66.7999C68.945 24 70.7 25.8 70.7 28V60C70.7 62.2 68.945 64 66.7999 64ZM62.9 32H55.1V40H62.9V32ZM62.9 48H55.1V56H62.9V48Z"
            fill="#802392"
          />
        </svg>
        <h2>Business Information</h2>
        <div className="business-information-data-list">
          <ul>
            <li>
              <strong>Business Name</strong>
              {userToEdit !== null && userToEdit !== undefined && (
                <span>{userToEdit?.businessName}</span>
              )}
            </li>
            <li>
              <strong>Business ID</strong>

              {userToEdit !== null && userToEdit !== undefined && (
                <span>{userToEdit!.businessCode}</span>
              )}
            </li>
            <li>
              <strong>Workstation Name</strong>
              {userToEdit !== null && userToEdit !== undefined && (
                <span>{userToEdit!.workstationName}</span>
              )}
            </li>
            <li>
              <strong>Workstation ID</strong>
              {userToEdit !== null && userToEdit !== undefined && (
                <span>{userToEdit!.workstationCode}</span>
              )}
            </li>
          </ul>
        </div>
        <IonButton
          className="blue-btn"
          onClick={() => {
            handleClick();
          }}
          placeholder={undefined}
        >
          Close
        </IonButton>
      </div>
    </IonContent>
  );
};

export default BusinessInformationModal;
